import React from 'react'
import PropTypes from 'prop-types'
import UGLayout from '../../../helpers/UGLayout'

/** 
  UG001 is a Universal Grid, which is a highly customisable grid 
  that can be easily edited by the authors. 
  The mobile layout can be set to either stack or slider and 
  it can hold 1-3 components arranged in a row:

  - 1 component = full width
  - 2 components = 2/3 + 1/3 (or 1/3 + 2/3 if flipOrientation is set to true)
  - 3 components = 1/2 + 1/4 + 1/4 (or 1/4 + 1/4 + 1/2 if flipOrientation is set to true)
* */
const UG001 = ({ consumingGridType, categoryId, included, imageStyle, mobileLayout, onLinkClick, flipOrientation }) => {
  const minLength = 1
  const maxLength = 3
  const numberOfComponents = included.length
  if (numberOfComponents < minLength || numberOfComponents > maxLength) return null

  const UGLayoutProps = {
    consumingGridType,
    categoryId,
    included,
    imageStyle,
    mobileLayout,
    onLinkClick,
    flipOrientation
  }

  return <UGLayout {...UGLayoutProps} />
}

UG001.propTypes = {
  /** name of the grid passed down to child components. defaults to ug001 */
  consumingGridType: PropTypes.string,
  /** categoryId passed down to child components. Used by components on argos browse */
  categoryId: PropTypes.string,
  /** imageStyle passed down to child components */
  imageStyle: PropTypes.oneOf(['normal', 'short', 'square', 'portrait']),
  /** Array of child components to be rendered inside the grid */
  included: PropTypes.arrayOf(PropTypes.shape).isRequired,
  /** layout of the grid components when displayed on smaller screen devices  */
  mobileLayout: PropTypes.oneOf(['slider', 'stack']),
  /** function passed down to child components */
  onLinkClick: PropTypes.func,
  /** defines how the components are split on the row, defaults to false -> larger first followed by the smaller ones */
  flipOrientation: PropTypes.bool
}

UG001.defaultProps = {
  categoryId: '',
  consumingGridType: 'ug001',
  imageStyle: 'short',
  mobileLayout: 'stack',
  onLinkClick: null,
  flipOrientation: false
}

export default UG001
